export default {
    props: {
        aggregate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'aggregate'
        }, 
        axis: {
            type: String,
            default: undefined,
            kComposite: 'axis'
        }, 
        borderColor: {
            type: [String, Function],
            default: undefined,
            kComposite: 'border.color'
        }, 
        borderDashType: {
            type: [String, Function],
            default: undefined,
            kComposite: 'border.dashType'
        }, 
        borderOpacity: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'border.opacity'
        }, 
        borderWidth: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'border.width'
        }, 
        categoryAxis: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis'
        }, 
        categoryField: {
            type: String,
            default: undefined,
            kComposite: 'categoryField'
        }, 
        closeField: {
            type: String,
            default: undefined,
            kComposite: 'closeField'
        }, 
        color: {
            type: [String, Function],
            default: undefined,
            kComposite: 'color'
        }, 
        colorField: {
            type: String,
            default: undefined,
            kComposite: 'colorField'
        }, 
        connectorsColor: {
            type: [String, Function],
            default: undefined,
            kComposite: 'connectors.color'
        }, 
        connectorsPadding: {
            type: Number,
            default: undefined,
            kComposite: 'connectors.padding'
        }, 
        connectorsWidth: {
            type: Number,
            default: undefined,
            kComposite: 'connectors.width'
        }, 
        currentField: {
            type: String,
            default: undefined,
            kComposite: 'currentField'
        }, 
        dashType: {
            type: String,
            default: undefined,
            kComposite: 'dashType'
        }, 
        data: {
            type: Array,
            default: undefined,
            kComposite: 'data'
        }, 
        downColor: {
            type: [String, Function],
            default: undefined,
            kComposite: 'downColor'
        }, 
        downColorField: {
            type: String,
            default: undefined,
            kComposite: 'downColorField'
        }, 
        segmentSpacing: {
            type: Number,
            default: undefined,
            kComposite: 'segmentSpacing'
        }, 
        summaryField: {
            type: String,
            default: undefined,
            kComposite: 'summaryField'
        }, 
        neckRatio: {
            type: Number,
            default: undefined,
            kComposite: 'neckRatio'
        }, 
        dynamicSlope: {
            type: Boolean,
            default: undefined,
            kComposite: 'dynamicSlope'
        }, 
        dynamicHeight: {
            type: Boolean,
            default: undefined,
            kComposite: 'dynamicHeight'
        }, 
        errorBarsValue: {
            type: [String, Number, Array, Function],
            default: undefined,
            kComposite: 'errorBars.value'
        }, 
        errorBarsVisual: {
            type: Function,
            default: undefined,
            kComposite: 'errorBars.visual'
        }, 
        errorBarsXValue: {
            type: [String, Number, Array, Function],
            default: undefined,
            kComposite: 'errorBars.xValue'
        }, 
        errorBarsYValue: {
            type: [String, Number, Array, Function],
            default: undefined,
            kComposite: 'errorBars.yValue'
        }, 
        errorBarsEndCaps: {
            type: Boolean,
            default: undefined,
            kComposite: 'errorBars.endCaps'
        }, 
        errorBarsColor: {
            type: String,
            default: undefined,
            kComposite: 'errorBars.color'
        }, 
        errorBarslineWidth: {
            type: Number,
            default: undefined,
            kComposite: 'errorBars.line.width'
        }, 
        errorBarslineDashType: {
            type: String,
            default: undefined,
            kComposite: 'errorBars.line.dashType'
        }, 
        errorLowField: {
            type: String,
            default: undefined,
            kComposite: 'errorLowField'
        }, 
        errorHighField: {
            type: String,
            default: undefined,
            kComposite: 'errorHighField'
        }, 
        xErrorLowField: {
            type: String,
            default: undefined,
            kComposite: 'xErrorLowField'
        }, 
        xErrorHighField: {
            type: String,
            default: undefined,
            kComposite: 'xErrorHighField'
        }, 
        yErrorLowField: {
            type: String,
            default: undefined,
            kComposite: 'yErrorLowField'
        }, 
        yErrorHighField: {
            type: String,
            default: undefined,
            kComposite: 'yErrorHighField'
        }, 
        explodeField: {
            type: String,
            default: undefined,
            kComposite: 'explodeField'
        }, 
        field: {
            type: String,
            default: undefined,
            kComposite: 'field'
        }, 
        fromField: {
            type: String,
            default: undefined,
            kComposite: 'fromField'
        }, 
        toField: {
            type: String,
            default: undefined,
            kComposite: 'toField'
        }, 
        noteTextField: {
            type: String,
            default: undefined,
            kComposite: 'noteTextField'
        }, 
        lowerField: {
            type: String,
            default: undefined,
            kComposite: 'lowerField'
        }, 
        q1Field: {
            type: String,
            default: undefined,
            kComposite: 'q1Field'
        }, 
        medianField: {
            type: String,
            default: undefined,
            kComposite: 'medianField'
        }, 
        q3Field: {
            type: String,
            default: undefined,
            kComposite: 'q3Field'
        }, 
        upperField: {
            type: String,
            default: undefined,
            kComposite: 'upperField'
        }, 
        meanField: {
            type: String,
            default: undefined,
            kComposite: 'meanField'
        }, 
        outliersField: {
            type: String,
            default: undefined,
            kComposite: 'outliersField'
        }, 
        gap: {
            type: Number,
            default: undefined,
            kComposite: 'gap'
        }, 
        highField: {
            type: String,
            default: undefined,
            kComposite: 'highField'
        }, 
        highlightBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'highlight.border.color'
        }, 
        highlightBorderOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'highlight.border.opacity'
        }, 
        highlightBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'highlight.border.width'
        }, 
        highlightColor: {
            type: String,
            default: undefined,
            kComposite: 'highlight.color'
        }, 
        highlightlineDashType: {
            type: String,
            default: undefined,
            kComposite: 'highlight.line.dashType'
        }, 
        highlightlineColor: {
            type: String,
            default: undefined,
            kComposite: 'highlight.line.color'
        }, 
        highlightlineOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'highlight.line.opacity'
        }, 
        highlightlineWidth: {
            type: Number,
            default: undefined,
            kComposite: 'highlight.line.width'
        }, 
        highlightOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'highlight.opacity'
        }, 
        highlightToggle: {
            type: Function,
            default: undefined,
            kComposite: 'highlight.toggle'
        }, 
        highlightVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'highlight.visible'
        }, 
        highlightVisual: {
            type: Function,
            default: undefined,
            kComposite: 'highlight.visual'
        }, 
        holeSize: {
            type: Number,
            default: undefined,
            kComposite: 'holeSize'
        }, 
        labelsAlign: {
            type: String,
            default: undefined,
            kComposite: 'labels.align'
        }, 
        labelsBackground: {
            type: [String, Function],
            default: undefined,
            kComposite: 'labels.background'
        }, 
        labelsBorderColor: {
            type: [String, Function],
            default: undefined,
            kComposite: 'labels.border.color'
        }, 
        labelsBorderDashType: {
            type: [String, Function],
            default: undefined,
            kComposite: 'labels.border.dashType'
        }, 
        labelsBorderWidth: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'labels.border.width'
        }, 
        labelsColor: {
            type: [String, Function],
            default: undefined,
            kComposite: 'labels.color'
        }, 
        labelsDistance: {
            type: Number,
            default: undefined,
            kComposite: 'labels.distance'
        }, 
        labelsFont: {
            type: [String, Function],
            default: undefined,
            kComposite: 'labels.font'
        }, 
        labelsFormat: {
            type: [String, Function],
            default: undefined,
            kComposite: 'labels.format'
        }, 
        labelsmargin: {
            type: Number,
            default: undefined,
            kComposite: 'labels.margin'
        }, 
        labelsmarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'labels.margin.bottom'
        }, 
        labelsmarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'labels.margin.left'
        }, 
        labelsmarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'labels.margin.right'
        }, 
        labelsmarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'labels.margin.top'
        }, 
        labelsPadding: {
            type: Number,
            default: undefined,
            kComposite: 'labels.padding'
        }, 
        labelsPaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'labels.padding.bottom'
        }, 
        labelsPaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'labels.padding.left'
        }, 
        labelsPaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'labels.padding.right'
        }, 
        labelsPaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'labels.padding.top'
        }, 
        labelsPosition: {
            type: [String, Function],
            default: undefined,
            kComposite: 'labels.position'
        }, 
        labelsRotation: {
            type: [String, Number],
            default: undefined,
            kComposite: 'labels.rotation'
        }, 
        labelsTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'labels.template'
        }, 
        labelsVisible: {
            type: [Boolean, Function],
            default: undefined,
            kComposite: 'labels.visible'
        }, 
        labelsVisual: {
            type: Function,
            default: undefined,
            kComposite: 'labels.visual'
        }, 
        labelsFromBackground: {
            type: [String, Function],
            default: undefined,
            kComposite: 'labels.from.background'
        }, 
        labelsFromBorderColor: {
            type: [String, Function],
            default: undefined,
            kComposite: 'labels.from.border.color'
        }, 
        labelsFromBorderDashType: {
            type: [String, Function],
            default: undefined,
            kComposite: 'labels.from.border.dashType'
        }, 
        labelsFromBorderWidth: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'labels.from.border.width'
        }, 
        labelsFromColor: {
            type: [String, Function],
            default: undefined,
            kComposite: 'labels.from.color'
        }, 
        labelsFromFont: {
            type: [String, Function],
            default: undefined,
            kComposite: 'labels.from.font'
        }, 
        labelsFromFormat: {
            type: [String, Function],
            default: undefined,
            kComposite: 'labels.from.format'
        }, 
        labelsFrommargin: {
            type: Number,
            default: undefined,
            kComposite: 'labels.from.margin'
        }, 
        labelsFrommarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'labels.from.margin.bottom'
        }, 
        labelsFrommarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'labels.from.margin.left'
        }, 
        labelsFrommarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'labels.from.margin.right'
        }, 
        labelsFrommarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'labels.from.margin.top'
        }, 
        labelsFromPadding: {
            type: Number,
            default: undefined,
            kComposite: 'labels.from.padding'
        }, 
        labelsFromPaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'labels.from.padding.bottom'
        }, 
        labelsFromPaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'labels.from.padding.left'
        }, 
        labelsFromPaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'labels.from.padding.right'
        }, 
        labelsFromPaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'labels.from.padding.top'
        }, 
        labelsFromPosition: {
            type: [String, Function],
            default: undefined,
            kComposite: 'labels.from.position'
        }, 
        labelsFromTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'labels.from.template'
        }, 
        labelsFromVisible: {
            type: [Boolean, Function],
            default: undefined,
            kComposite: 'labels.from.visible'
        }, 
        labelsToBackground: {
            type: [String, Function],
            default: undefined,
            kComposite: 'labels.to.background'
        }, 
        labelsToBorderColor: {
            type: [String, Function],
            default: undefined,
            kComposite: 'labels.to.border.color'
        }, 
        labelsToBorderDashType: {
            type: [String, Function],
            default: undefined,
            kComposite: 'labels.to.border.dashType'
        }, 
        labelsToBorderWidth: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'labels.to.border.width'
        }, 
        labelsToColor: {
            type: [String, Function],
            default: undefined,
            kComposite: 'labels.to.color'
        }, 
        labelsToFont: {
            type: [String, Function],
            default: undefined,
            kComposite: 'labels.to.font'
        }, 
        labelsToFormat: {
            type: [String, Function],
            default: undefined,
            kComposite: 'labels.to.format'
        }, 
        labelsTomargin: {
            type: Number,
            default: undefined,
            kComposite: 'labels.to.margin'
        }, 
        labelsTomarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'labels.to.margin.bottom'
        }, 
        labelsTomarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'labels.to.margin.left'
        }, 
        labelsTomarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'labels.to.margin.right'
        }, 
        labelsTomarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'labels.to.margin.top'
        }, 
        labelsToPadding: {
            type: Number,
            default: undefined,
            kComposite: 'labels.to.padding'
        }, 
        labelsToPaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'labels.to.padding.bottom'
        }, 
        labelsToPaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'labels.to.padding.left'
        }, 
        labelsToPaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'labels.to.padding.right'
        }, 
        labelsToPaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'labels.to.padding.top'
        }, 
        labelsToPosition: {
            type: [String, Function],
            default: undefined,
            kComposite: 'labels.to.position'
        }, 
        labelsToTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'labels.to.template'
        }, 
        labelsToVisible: {
            type: [Boolean, Function],
            default: undefined,
            kComposite: 'labels.to.visible'
        }, 
        line: {
            type: String,
            default: undefined,
            kComposite: 'line'
        }, 
        lineColor: {
            type: String,
            default: undefined,
            kComposite: 'line.color'
        }, 
        lineOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'line.opacity'
        }, 
        lineWidth: {
            type: String,
            default: undefined,
            kComposite: 'line.width'
        }, 
        lineStyle: {
            type: String,
            default: undefined,
            kComposite: 'line.style'
        }, 
        lowField: {
            type: String,
            default: undefined,
            kComposite: 'lowField'
        }, 
        margin: {
            type: Number,
            default: undefined,
            kComposite: 'margin'
        }, 
        marginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'margin.bottom'
        }, 
        marginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'margin.left'
        }, 
        marginRight: {
            type: Number,
            default: undefined,
            kComposite: 'margin.right'
        }, 
        marginTop: {
            type: Number,
            default: undefined,
            kComposite: 'margin.top'
        }, 
        markersBackground: {
            type: [String, Function],
            default: undefined,
            kComposite: 'markers.background'
        }, 
        markersBorder: {
            type: Function,
            default: undefined,
            kComposite: 'markers.border'
        }, 
        markersBorderColor: {
            type: [String, Function],
            default: undefined,
            kComposite: 'markers.border.color'
        }, 
        markersBorderWidth: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'markers.border.width'
        }, 
        markersFromBackground: {
            type: [String, Function],
            default: undefined,
            kComposite: 'markers.from.background'
        }, 
        markersFromBorder: {
            type: Function,
            default: undefined,
            kComposite: 'markers.from.border'
        }, 
        markersFromBorderColor: {
            type: [String, Function],
            default: undefined,
            kComposite: 'markers.from.border.color'
        }, 
        markersFromBorderWidth: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'markers.from.border.width'
        }, 
        markersFromSize: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'markers.from.size'
        }, 
        markersFromType: {
            type: [String, Function],
            default: undefined,
            kComposite: 'markers.from.type'
        }, 
        markersFromVisible: {
            type: [Boolean, Function],
            default: undefined,
            kComposite: 'markers.from.visible'
        }, 
        markersFromVisual: {
            type: Function,
            default: undefined,
            kComposite: 'markers.from.visual'
        }, 
        markersFromRotation: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'markers.from.rotation'
        }, 
        markersSize: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'markers.size'
        }, 
        markersToBackground: {
            type: [String, Function],
            default: undefined,
            kComposite: 'markers.to.background'
        }, 
        markersToBorder: {
            type: Function,
            default: undefined,
            kComposite: 'markers.to.border'
        }, 
        markersToBorderColor: {
            type: [String, Function],
            default: undefined,
            kComposite: 'markers.to.border.color'
        }, 
        markersToBorderWidth: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'markers.to.border.width'
        }, 
        markersToSize: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'markers.to.size'
        }, 
        markersToType: {
            type: [String, Function],
            default: undefined,
            kComposite: 'markers.to.type'
        }, 
        markersToVisible: {
            type: [Boolean, Function],
            default: undefined,
            kComposite: 'markers.to.visible'
        }, 
        markersToVisual: {
            type: Function,
            default: undefined,
            kComposite: 'markers.to.visual'
        }, 
        markersToRotation: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'markers.to.rotation'
        }, 
        markersType: {
            type: [String, Function],
            default: undefined,
            kComposite: 'markers.type'
        }, 
        markersVisible: {
            type: [Boolean, Function],
            default: undefined,
            kComposite: 'markers.visible'
        }, 
        markersVisual: {
            type: Function,
            default: undefined,
            kComposite: 'markers.visual'
        }, 
        markersRotation: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'markers.rotation'
        }, 
        outliersBackground: {
            type: [String, Function],
            default: undefined,
            kComposite: 'outliers.background'
        }, 
        outliersBorder: {
            type: Function,
            default: undefined,
            kComposite: 'outliers.border'
        }, 
        outliersBorderColor: {
            type: [String, Function],
            default: undefined,
            kComposite: 'outliers.border.color'
        }, 
        outliersBorderWidth: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'outliers.border.width'
        }, 
        outliersSize: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'outliers.size'
        }, 
        outliersType: {
            type: [String, Function],
            default: undefined,
            kComposite: 'outliers.type'
        }, 
        outliersRotation: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'outliers.rotation'
        }, 
        extremesBackground: {
            type: [String, Function],
            default: undefined,
            kComposite: 'extremes.background'
        }, 
        extremesBorder: {
            type: Function,
            default: undefined,
            kComposite: 'extremes.border'
        }, 
        extremesBorderColor: {
            type: [String, Function],
            default: undefined,
            kComposite: 'extremes.border.color'
        }, 
        extremesBorderWidth: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'extremes.border.width'
        }, 
        extremesSize: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'extremes.size'
        }, 
        extremesType: {
            type: [String, Function],
            default: undefined,
            kComposite: 'extremes.type'
        }, 
        extremesRotation: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'extremes.rotation'
        }, 
        maxSize: {
            type: Number,
            default: undefined,
            kComposite: 'maxSize'
        }, 
        minSize: {
            type: Number,
            default: undefined,
            kComposite: 'minSize'
        }, 
        missingValues: {
            type: String,
            default: undefined,
            kComposite: 'missingValues'
        }, 
        kStyle: {
            type: String,
            default: undefined,
            kComposite: 'style'
        }, 
        name: {
            type: String,
            default: undefined,
            kComposite: 'name'
        }, 
        negativeColor: {
            type: String,
            default: undefined,
            kComposite: 'negativeColor'
        }, 
        negativeValuesColor: {
            type: String,
            default: undefined,
            kComposite: 'negativeValues.color'
        }, 
        negativeValuesVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'negativeValues.visible'
        }, 
        opacity: {
            type: Number,
            default: undefined,
            kComposite: 'opacity'
        }, 
        openField: {
            type: String,
            default: undefined,
            kComposite: 'openField'
        }, 
        overlayGradient: {
            type: String,
            default: undefined,
            kComposite: 'overlay.gradient'
        }, 
        padding: {
            type: Number,
            default: undefined,
            kComposite: 'padding'
        }, 
        size: {
            type: Number,
            default: undefined,
            kComposite: 'size'
        }, 
        sizeField: {
            type: String,
            default: undefined,
            kComposite: 'sizeField'
        }, 
        spacing: {
            type: Number,
            default: undefined,
            kComposite: 'spacing'
        }, 
        stack: {
            type: [Boolean, String],
            default: undefined,
            kComposite: 'stack'
        }, 
        stackType: {
            type: String,
            default: undefined,
            kComposite: 'stack.type'
        }, 
        stackGroup: {
            type: String,
            default: undefined,
            kComposite: 'stack.group'
        }, 
        startAngle: {
            type: Number,
            default: undefined,
            kComposite: 'startAngle'
        }, 
        targetBorder: {
            type: Function,
            default: undefined,
            kComposite: 'target.border'
        }, 
        targetBorderColor: {
            type: [String, Function],
            default: undefined,
            kComposite: 'target.border.color'
        }, 
        targetBorderDashType: {
            type: [String, Function],
            default: undefined,
            kComposite: 'target.border.dashType'
        }, 
        targetBorderWidth: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'target.border.width'
        }, 
        targetColor: {
            type: [String, Function],
            default: undefined,
            kComposite: 'target.color'
        }, 
        targetlineWidth: {
            type: [Object, Function],
            default: undefined,
            kComposite: 'target.line.width'
        }, 
        targetField: {
            type: String,
            default: undefined,
            kComposite: 'targetField'
        }, 
        tooltipBackground: {
            type: String,
            default: undefined,
            kComposite: 'tooltip.background'
        }, 
        tooltipBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'tooltip.border.color'
        }, 
        tooltipBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'tooltip.border.width'
        }, 
        tooltipColor: {
            type: String,
            default: undefined,
            kComposite: 'tooltip.color'
        }, 
        tooltipFont: {
            type: String,
            default: undefined,
            kComposite: 'tooltip.font'
        }, 
        tooltipFormat: {
            type: String,
            default: undefined,
            kComposite: 'tooltip.format'
        }, 
        tooltipPadding: {
            type: Number,
            default: undefined,
            kComposite: 'tooltip.padding'
        }, 
        tooltipPaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'tooltip.padding.bottom'
        }, 
        tooltipPaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'tooltip.padding.left'
        }, 
        tooltipPaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'tooltip.padding.right'
        }, 
        tooltipPaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'tooltip.padding.top'
        }, 
        tooltipTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'tooltip.template'
        }, 
        tooltipVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'tooltip.visible'
        }, 
        type: {
            type: String,
            default: undefined,
            kComposite: 'type'
        }, 
        visible: {
            type: Boolean,
            default: undefined,
            kComposite: 'visible'
        },
        visibleInLegend: {
            type: Boolean,
            default: undefined,
            kComposite: 'visibleInLegend'
        }, 
        visibleInLegendField: {
            type: String,
            default: undefined,
            kComposite: 'visibleInLegendField'
        }, 
        visual: {
            type: Function,
            default: undefined,
            kComposite: 'visual'
        }, 
        width: {
            type: Number,
            default: undefined,
            kComposite: 'width'
        }, 
        xAxis: {
            type: String,
            default: undefined,
            kComposite: 'xAxis'
        }, 
        xField: {
            type: String,
            default: undefined,
            kComposite: 'xField'
        }, 
        yAxis: {
            type: String,
            default: undefined,
            kComposite: 'yAxis'
        }, 
        yField: {
            type: String,
            default: undefined,
            kComposite: 'yField'
        }, 
        notesPosition: {
            type: String,
            default: undefined,
            kComposite: 'notes.position'
        }, 
        notesIconBackground: {
            type: String,
            default: undefined,
            kComposite: 'notes.icon.background'
        }, 
        notesIconBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'notes.icon.border.color'
        }, 
        notesIconBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'notes.icon.border.width'
        }, 
        notesIconSize: {
            type: Number,
            default: undefined,
            kComposite: 'notes.icon.size'
        }, 
        notesIconType: {
            type: String,
            default: undefined,
            kComposite: 'notes.icon.type'
        }, 
        notesIconVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'notes.icon.visible'
        }, 
        notesLabelBackground: {
            type: String,
            default: undefined,
            kComposite: 'notes.label.background'
        }, 
        notesLabelBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'notes.label.border.color'
        }, 
        notesLabelBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'notes.label.border.dashType'
        }, 
        notesLabelBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'notes.label.border.width'
        }, 
        notesLabelColor: {
            type: String,
            default: undefined,
            kComposite: 'notes.label.color'
        }, 
        notesLabelFont: {
            type: String,
            default: undefined,
            kComposite: 'notes.label.font'
        }, 
        notesLabelTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'notes.label.template'
        }, 
        notesLabelVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'notes.label.visible'
        }, 
        notesLabelRotation: {
            type: Number,
            default: undefined,
            kComposite: 'notes.label.rotation'
        }, 
        notesLabelFormat: {
            type: String,
            default: undefined,
            kComposite: 'notes.label.format'
        }, 
        notesLabelPosition: {
            type: String,
            default: undefined,
            kComposite: 'notes.label.position'
        }, 
        noteslineDashType: {
            type: String,
            default: undefined,
            kComposite: 'notes.line.dashType'
        }, 
        noteslineWidth: {
            type: Number,
            default: undefined,
            kComposite: 'notes.line.width'
        }, 
        noteslineColor: {
            type: String,
            default: undefined,
            kComposite: 'notes.line.color'
        }, 
        noteslineLength: {
            type: Number,
            default: undefined,
            kComposite: 'notes.line.length'
        }, 
        notesVisual: {
            type: Function,
            default: undefined,
            kComposite: 'notes.visual'
        }, 
        zIndex: {
            type: Number,
            default: undefined,
            kComposite: 'zIndex'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-charts-vue-wrapper/src/KendoChartSeriesItem/Series.js